import * as React from "react";
import Swiper, { A11y, Pagination, Navigation } from "swiper";
import AspectRatio from "@components/primitives/aspect-ratio";
import { Shopify } from "@models/shopify.model";

import { ReactComponent as CaretSVG } from "@images/caret.svg";

import * as Styled from "./BundleSlider.styled";

const { useRef, useEffect } = React;

Swiper.use([A11y, Navigation, Pagination]);

const padNumber = (num: number) => {
  return num < 10 ? `0${num}` : num;
};

export interface BundleSliderProps {
  images: Array<Shopify.Image>;
}

const BundleSlider: React.FC<BundleSliderProps> = ({ images }) => {
  const swiperElRef = useRef<HTMLDivElement | undefined>();
  const swiperInstanceRef = useRef<any | undefined>();

  useEffect(() => {
    if (!swiperElRef.current) return;

    if (images.length > 1) {
      swiperInstanceRef.current = new Swiper(swiperElRef.current, {
        loop: true,
        slidesPerView: 1,
        a11y: {
          prevSlideMessage: "Previous press slide",
          nextSlideMessage: "Next press slide",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "custom",
          renderCustom: (swiper, current, total) => {
            return `
              <div class="swiper-pagination-item">
                <span>
                  <span>${padNumber(current)}</span>/<span>${padNumber(total)}</span>:
                </span>
                <span>${images[current - 1]?.altText || "The Mirror"}</span>
              </div>
            `;
          },
        },
      });
    }

    return () => {
      if (swiperInstanceRef.current) {
        swiperInstanceRef.current.destroy();
      }
    };
  }, [images]);

  return (
    <Styled.BundleSlider>
      <div className="swiper-container" ref={swiperElRef}>
        <div className="swiper-wrapper">
          {images &&
            images.map((img, idx) => {
              return (
                <div className="swiper-slide" key={idx}>
                  <AspectRatio ratio={580 / 642}>
                    {img.src && <img src={img.src} alt={img.altText || ""} loading="lazy" />}
                  </AspectRatio>

                  {images.length == 1 && (
                    <span className="swiper-caption">{images[0]?.altText || "The Mirror"}</span>
                  )}
                </div>
              );
            })}
        </div>

        {images.length > 1 && (
          <>
            <button className="swiper-button-prev">
              <CaretSVG />
            </button>

            <button className="swiper-button-next">
              <CaretSVG />
            </button>

            <div className="swiper-pagination"></div>
          </>
        )}
      </div>
    </Styled.BundleSlider>
  );
};

export default BundleSlider;
